import { useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'

// Components
import Layout from './components/Layout'
import PrivateRoute from './components/PrivateRoute'
import AdminRoute from './components/AdminRoute'

// Pages
import Login from './pages/Login'
import Register from './pages/Register'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import Dashboard from './pages/Dashboard'
import Licenses from './pages/Licenses'
import Devices from './pages/Devices'
import Sessions from './pages/Sessions'
import Payments from './pages/Payments'
import Profile from './pages/Profile'
import Settings from './pages/Settings'
import Help from './pages/Help'
import PaymentSuccess from './pages/PaymentSuccess'
import PaymentCancel from './pages/PaymentCancel'
import AdminPayments from './pages/AdminPayments'
import UserInvoices from './pages/UserInvoices'
import AdminSecurity from './pages/AdminSecurity'

// Admin Pages
import AdminDashboard from './pages/admin/AdminDashboard'
import UserManagement from './pages/admin/UserManagement'
import LicenseManagement from './pages/admin/LicenseManagement'
import EmailSettings from './pages/admin/EmailSettings'
import CompanySettings from './pages/admin/CompanySettings'

// Services
// import { authAPI } from './services/api'

function App() {
  useEffect(() => {
    // Check auth on mount - simplified without verify endpoint
    const checkAuth = async () => {
      const token = localStorage.getItem('token')
      if (!token) {
        // No token, user needs to login
        return
      }
      // Token exists, assume valid for now
    }
    checkAuth()
  }, [])

  return (
    <BrowserRouter basename="/panel-clic">
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#1f2937',
            color: '#fff',
            border: '1px solid #374151'
          }
        }}
      />
      
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        
        {/* Private routes */}
        <Route element={<PrivateRoute />}>
          <Route element={<Layout />}>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/licenses" element={<Licenses />} />
            <Route path="/devices" element={<Devices />} />
            <Route path="/sessions" element={<Sessions />} />
            <Route path="/payments" element={<Payments />} />
            <Route path="/invoices" element={<UserInvoices />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/help" element={<Help />} />
            
            {/* Admin routes */}
            <Route element={<AdminRoute />}>
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/users" element={<UserManagement />} />
              <Route path="/admin/licenses" element={<LicenseManagement />} />
              <Route path="/admin/payments" element={<AdminPayments />} />
              <Route path="/admin/security" element={<AdminSecurity />} />
              <Route path="/admin/email-settings" element={<EmailSettings />} />
              <Route path="/admin/company-settings" element={<CompanySettings />} />
            </Route>
          </Route>
        </Route>
        
        {/* Catch all */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App